import 'react-calendar/dist/Calendar.css';
import 'react-datetime-picker/dist/DateTimePicker.css';

import { IInputProps } from 'modules';
import React, { useEffect, useState } from 'react';
import DateTimePicker from 'react-datetime-picker';

export const InputDateTime = (props: IInputProps) => {
  const [value, setValue] = useState(null) as any;

  useEffect(() => {
    if (props.value !== undefined) {
      setValue(props.value);
    } else if (props.defaultValue !== undefined) {
      setValue(props.defaultValue);
    }
  }, [props.value, props.defaultValue]);

  const handleChange = (date: any) => {
    if (date) {
      setValue(date);
      props.onChange(date);
      props.onChangeCallback?.(date);
    } else {
      setValue(null);
      props.onChange(null);
      props.onChangeCallback?.(null);
    }
  };

  const convertTime = (time: any) => {
    if (!time) return null;
    if (time instanceof Date) return time;
    return new Date(time);
  };

  return (
    <DateTimePicker
      className='InputDateTime'
      calendarClassName='InputDateTimeCalendar'
      clockClassName='InputDateTimeClock'
      // maxDetail={maxDetail}
      disableClock={true}
      onChange={handleChange}
      // minDate={convertTime(minDate)}
      // maxDate={convertTime(maxDate)}
      // time={true}
      format={props?.dateTimeFormat || 'dd/MM/yyyy HH:mm:ss'}
      value={convertTime(value)}
      locale='vi-VN'
      disabled={props.isDisabled}
      onCalendarClose={() => props.onTouched()}
      onBlur={() => props.onTouched()}
      clearIcon={null}
    />
  );
};
